import { Container, Divider, Heading } from "@chakra-ui/react";
import CardForm from "components/ui/CardForm";
import HeaderBarInternal from "components/ui/HeaderBarInternal";
import PersonForm from "../components/PersonForm";

export default function PageCreatePerson() {
  return (
    <>
      <HeaderBarInternal title="Novo parlamentar" backTo="/parlamentares" />
      <Divider />

      <Container variant="internal" flexDirection="column">
        <Heading as="h1" size="h1">
          Dados do parlamentar
          <span>Identifique um novo parlamentar Patri</span>
        </Heading>

        <CardForm>
          <PersonForm />
        </CardForm>
      </Container>
    </>
  );
}
